<template>
  <pt-pt-batch-monitoring-table class="pt-pt-batch-monitoring-table__withData" ref="table" @getTableData="getTableData" :tableLabels="tableLabels"
  :totalNumber="totalNumber" :tableData="tableData"></pt-pt-batch-monitoring-table>
</template>

<script>
import PtPtBatchMonitoringTable from './index'
export default {
  name: 'pt-pt-batch-monitoring-table__withData',
  components: {
    'pt-pt-batch-monitoring-table': PtPtBatchMonitoringTable
  },
  computed: {
    page () {
      return this.$refs.table.page
    }
  },
  props: {
    pageSize: {
      type: Number,
      default: 10
    },
    tableLabels: {
      type: Array,
      default: function () {
        return []
      }
    },
    queryParams: {
      type: Object,
      default: function () {
        return {}
      }
    },
    isFromRouter: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      tableData: [],
      totalNumber: 0
    }
  },
  watch: {
    queryParams: {
      handler: function (val) {
        if (!this.isFromRouter) {
          console.log('0')
          this.$refs.table.resetPage()
        } else {
          console.log(1)
          this.isOutside = true
          this.getTableData(this.page)
        }
      },
      deep: true
    }
  },
  methods: {
    getTableData (page, next) {
      console.log('this.queryParams', this.queryParams)
      let data = {
        business: [
          'user',
          'contract',
          'order',
          'basic_report',
          'year_report'
        ],
        pageable: {
          page: this.page,
          size: this.pageSize,
          sort: [
            'id,desc'
          ]
        },
        ...this.queryParams
      }
      this.$store.dispatch('getgetExceptionList', data).then(res => {
        this.tableData = res.data
        this.totalNumber = res.totalNumber
        if (next) {
          next(res.data)
        }
      }).catch(err => {
        this.$message.error(err || '获取异常列表失败')
      })
    }
  }
}
</script>
